module.exports = __webpack_public_path__ + "static/img/6.3968108e.jpg";